var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitilliumWebV8LatinRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "TitilliumWeb",
    horizAdvX: 493
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Titillium Web",
    unitsPerEm: 1000,
    panose1: "0 0 5 0 0 0 0 0 0 0",
    ascent: 1133,
    descent: -388,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    glyphName: "space",
    horizAdvX: 220
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    glyphName: "exclam",
    horizAdvX: 247,
    d: "M83 0V112H165V0H83ZM89 228L84 692H163L158 228H89Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    glyphName: "quotedbl",
    horizAdvX: 373,
    d: "M303 470H236L232 692H307L303 470ZM137 470H70L66 692H141L137 470Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    glyphName: "numbersign",
    horizAdvX: 560,
    d: "M536 174H425V0H357V174H203V0H135V174H24V238H135V424H24V488H135V666H203V488H357V666H425V488H536V424H425V238H536V174ZM357 238V424H203V238H357Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    glyphName: "dollar",
    horizAdvX: 560,
    d: "M494 194Q494 -9 283 -9H268L254 -124Q203 -121 203 -117L217 -6L74 12L82 73Q159 62 225 58L258 308Q156 332 113 369T69 493Q69 670 281 670Q296 670 304 669L321 798H372L355 666L480 651L474 589Q405 597 347 602L317 369Q414 346 454 310T494 194ZM143 497Q143 443 170 420T267 380L296 605H286Q143 605 143 497ZM420 189Q420 237 395 260T308 298L277 56H279Q420 56 420 189Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    glyphName: "percent",
    horizAdvX: 560,
    d: "M155 -4L360 681L408 665L203 -18L155 -4ZM28 670T138 670T248 532Q248 461 219 426T138 391T57 426T28 532Q28 670 138 670ZM89 532Q89 442 138 442T188 532Q188 577 177 598T139 619T101 598T89 532ZM313 132Q313 269 422 269T532 131Q532 61 503 26T422 -10T342 25T313 132ZM373 132Q373 41 422 41Q450 41 461 63T472 131T461 197T423 218T385 198T373 132Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    glyphName: "ampersand",
    horizAdvX: 688,
    d: "M140 621T186 661T316 701T443 661T487 551T452 440T333 360L485 210Q507 274 513 372L586 371Q573 246 540 163L669 41L624 -9L503 104Q434 -10 294 -10T98 44T42 193T78 333T197 405Q162 445 151 476T140 554Q140 621 186 661ZM282 58Q405 58 451 148L240 358Q174 337 146 304T118 202Q118 58 282 58ZM215 542Q215 481 260 433L289 405Q358 435 385 464T412 544Q412 636 314 636T215 542Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    glyphName: "quotesingle",
    horizAdvX: 208,
    d: "M70 470L67 692H142L137 470H70Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    glyphName: "parenleft",
    horizAdvX: 264,
    d: "M155 -125Q51 109 51 301Q51 397 77 509T129 686L155 750H227Q192 658 162 523T132 302T156 110T204 -61L227 -125H155Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    glyphName: "parenright",
    horizAdvX: 264,
    d: "M202 431Q213 361 213 283T187 99T135 -66L109 -125H37Q71 -45 101 85T132 301T109 499T61 680L37 750H109Q175 601 202 431Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    glyphName: "asterisk",
    horizAdvX: 420,
    d: "M373 511H241L282 386L233 371L192 497L85 418L54 458L162 537L56 614L87 656L193 578L234 704L283 688L243 561H373V511Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    glyphName: "plus",
    horizAdvX: 560,
    d: "M55 217V285H244V480H314V285H505V217H314V20H244V217H55Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    glyphName: "comma",
    horizAdvX: 223,
    d: "M34 -123L80 107H163L96 -123H34Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    glyphName: "hyphen",
    horizAdvX: 438,
    d: "M68 240V310H371V240H68Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    glyphName: "period",
    horizAdvX: 216,
    d: "M67 0V114H149V0H67Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    glyphName: "slash",
    horizAdvX: 412,
    d: "M32 10L314 708L381 683L99 -14L32 10Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    glyphName: "zero",
    horizAdvX: 560,
    d: "M279 671Q361 671 412 640Q520 576 520 320Q520 139 460 65T280 -10T100 63T39 325T98 592T279 671ZM280 602Q223 602 190 578Q119 529 119 319Q119 171 158 115T280 58T402 115T441 326T404 541T280 602Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    glyphName: "one",
    horizAdvX: 560,
    d: "M389 660V0H312V574L142 462L107 520L317 660H389Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    glyphName: "two",
    horizAdvX: 560,
    d: "M491 0H69V65L262 268Q312 320 335 347T376 411T395 485Q395 549 360 575T251 601Q186 601 106 584L80 579L74 643Q169 670 270 670T422 628T474 493Q474 423 443 371T336 246L160 67H491V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    glyphName: "three",
    horizAdvX: 560,
    d: "M72 643Q166 671 273 671T429 630T477 499Q477 453 465 433T445 401T425 380Q403 363 390 356L379 349Q437 328 465 296T493 189Q493 88 442 39T279 -10Q191 -10 93 10L62 17L69 80Q177 58 271 58Q414 59 414 186Q414 305 278 310H145V376H278Q320 376 359 409T398 498T367 577T263 602Q183 602 105 587L79 582L72 643Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    glyphName: "four",
    horizAdvX: 560,
    d: "M360 0V129H40V189L228 660H312L121 197H360V403H437V197H521V129H437V0H360Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    glyphName: "five",
    horizAdvX: 560,
    d: "M477 660V590H156L138 375Q215 416 293 416Q503 416 503 221Q503 109 445 50T282 -9Q198 -9 96 13L63 20L72 81Q187 59 265 59T384 99T424 213T388 316T284 347Q248 347 209 337T148 317L127 307L74 317L92 660H477Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    glyphName: "six",
    horizAdvX: 560,
    d: "M482 590Q392 602 307 602T176 543T130 374L155 384Q180 393 221 403T295 413Q517 413 517 208Q517 103 457 47T286 -10Q50 -10 50 333Q50 506 117 588T308 670Q389 670 462 658L489 653L482 590ZM290 344Q256 344 216 335T152 316L129 306Q130 192 167 125T282 58T398 96T437 205T399 310T290 344Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    glyphName: "seven",
    horizAdvX: 560,
    d: "M77 590V660H487V559L233 -10L160 13L409 564V590H77Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    glyphName: "eight",
    horizAdvX: 560,
    d: "M168 671T278 671T452 628T517 499Q517 437 492 405T407 345Q467 318 497 282T527 179Q527 -10 280 -10T32 168Q32 239 59 276T146 345Q92 372 68 406T43 500Q43 584 105 627ZM114 181Q114 60 279 60T445 187Q445 240 416 265T328 308H223Q168 293 141 264T114 181ZM435 490Q435 601 280 601T125 491Q125 447 149 420T223 375H328Q382 392 408 419T435 490Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    glyphName: "nine",
    horizAdvX: 560,
    d: "M247 58Q428 58 429 288Q329 250 257 250Q41 250 41 451Q41 552 103 611T270 670Q391 670 450 581T509 318T443 67T247 -10Q172 -10 92 4L66 8L73 70Q163 58 247 58ZM263 318Q324 318 404 345L430 354Q427 602 270 602Q200 602 161 562T121 451Q121 318 263 318Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    glyphName: "colon",
    horizAdvX: 217,
    d: "M67 322V436H149V322H67ZM67 0V114H149V0H67Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    glyphName: "semicolon",
    horizAdvX: 248,
    d: "M93 107H177L110 -123H48L93 107ZM88 322V436H169V322H88Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    glyphName: "less",
    horizAdvX: 560,
    d: "M477 409L138 252L477 92V13L61 218V284L477 487V409Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    glyphName: "equal",
    horizAdvX: 560,
    d: "M64 309V378H496V309H64ZM64 124V193H496V124H64Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    glyphName: "greater",
    horizAdvX: 560,
    d: "M421 252L82 409V487L498 284V218L82 13V92L421 252Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    glyphName: "question",
    horizAdvX: 447,
    d: "M406 542Q406 477 389 444T318 366T244 295T224 236V201H161Q148 228 148 262T171 325T245 399T313 469T330 541T298 611T197 634Q153 634 68 616L42 611L37 672Q138 702 204 702Q307 702 356 665T406 542ZM150 1V113H232V1H150Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    glyphName: "at",
    horizAdvX: 977,
    d: "M933 305V292Q933 80 866 25Q842 6 818 0T762 -6T708 0T673 15Q649 33 640 54Q542 -5 466 -5Q429 -5 402 4T346 38Q290 88 290 233T335 441T493 505Q536 505 590 486L608 479V495H683V304Q683 129 694 96Q699 83 708 72T729 59T767 57T812 70T844 136T857 292V306Q857 491 775 574T503 657T220 563T127 256T215 -47T504 -137L647 -127L650 -194Q556 -203 504 -203Q388 -203 308 -181T168 -106Q51 -4 51 261Q51 502 166 612T504 723T830 621T933 305ZM471 61Q514 61 617 107Q608 161 608 280V419Q548 439 505 439Q424 439 395 393T366 244Q366 61 471 61Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    glyphName: "A",
    horizAdvX: 596,
    d: "M24 0L214 692H382L572 0H496L446 178H150L100 0H24ZM272 626L167 247H429L324 626H272Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    glyphName: "B",
    horizAdvX: 616,
    d: "M85 692H336Q439 692 490 650T542 516Q542 451 520 415T453 357Q563 319 563 194Q563 90 508 45T349 0H85V692ZM341 318H162V68H346Q414 68 449 96T485 197Q485 235 471 261T432 298Q388 318 341 318ZM333 624H162V385H340Q404 385 433 415T463 507T432 596T333 624Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    glyphName: "C",
    horizAdvX: 544,
    d: "M503 11Q400 -10 318 -10T186 12T108 82T70 191T59 345T69 499T107 610T185 680T315 702T503 680L500 615Q399 633 320 633Q210 633 175 568T139 344Q139 265 145 217T171 131T226 76T333 59T500 77L503 11Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    glyphName: "D",
    horizAdvX: 645,
    d: "M332 0H85V692H332Q501 692 556 558Q588 481 588 356Q588 95 458 27Q406 0 332 0ZM509 356Q509 555 420 604Q384 624 332 624H162V68H332Q509 68 509 356Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    glyphName: "E",
    horizAdvX: 553,
    d: "M85 0V692H506V624H162V385H446V318H162V68H506V0H85Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    glyphName: "F",
    horizAdvX: 526,
    d: "M85 0V692H499V624H162V354H447V286H162V0H85Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    glyphName: "G",
    horizAdvX: 616,
    d: "M359 285V354H550V14Q424 -10 325 -10Q174 -10 116 77T57 345T115 614T323 702Q416 702 516 682L550 676L547 612Q423 633 332 633Q217 633 177 567T137 346T177 125T331 58Q401 58 474 72V285H359Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    glyphName: "H",
    horizAdvX: 675,
    d: "M514 0V313H162V0H85V692H162V382H514V692H590V0H514Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    glyphName: "I",
    horizAdvX: 246,
    d: "M85 0V692H162V0H85Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    glyphName: "J",
    horizAdvX: 289,
    d: "M18 -72V-3Q90 -3 110 14T131 106V692H207L208 95Q208 11 180 -28Q157 -61 89 -69Q62 -72 18 -72Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    glyphName: "K",
    horizAdvX: 569,
    d: "M162 0H85V692H162V370L276 374L453 692H541L343 344L552 0H461L277 306L162 302V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    glyphName: "L",
    horizAdvX: 479,
    d: "M466 0H85V692H162V69H466V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    glyphName: "M",
    horizAdvX: 840,
    d: "M85 0V692H224L420 107L616 692H755V0H678V610H664L463 25H377L176 610H162V0H85Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    glyphName: "N",
    horizAdvX: 676,
    d: "M85 0V692H229L494 68H515V692H591V0H450L181 624H162V0H85Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    glyphName: "O",
    horizAdvX: 660,
    d: "M136 191T176 125T330 58T484 123T524 341T483 564T330 634T177 565T136 343ZM604 156T545 73T331 -10T116 75T57 342T117 613T330 702T543 614T604 341Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    glyphName: "P",
    horizAdvX: 593,
    d: "M338 233H162V0H85V692H338Q451 692 505 637T559 469Q559 233 338 233ZM162 301H337Q480 301 480 469Q480 549 446 586T337 624H162V301Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    glyphName: "Q",
    horizAdvX: 660,
    d: "M330 -10Q175 -10 116 75T57 342T117 613T330 702T543 614T604 343Q604 216 578 140T489 26L574 -111L502 -145L414 -1Q381 -10 330 -10ZM136 191T176 125T330 58T484 122T524 340T483 564T330 634T177 565T136 343Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    glyphName: "R",
    horizAdvX: 616,
    d: "M162 265V0H85V692H341Q451 692 506 641T562 482Q562 322 435 281L568 0H483L358 265H162ZM342 333Q483 333 483 478T341 624H162V333H342Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    glyphName: "S",
    horizAdvX: 542,
    d: "M276 635Q126 635 126 522Q126 459 160 436T300 389T450 328T494 204Q494 -9 273 -9Q200 -9 90 8L54 13L62 77Q198 59 269 59Q417 59 417 198Q417 254 385 278T263 320Q146 345 97 384T48 517Q48 703 271 703Q344 703 446 688L480 683L473 618Q334 635 276 635Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    glyphName: "T",
    horizAdvX: 526,
    d: "M13 623V692H513V623H302V0H226V623H13Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    glyphName: "U",
    horizAdvX: 644,
    d: "M157 208Q157 58 319 58Q403 58 445 93T488 208V692H564V210Q564 94 503 42T321 -10T141 42T80 210V692H157V208Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    glyphName: "V",
    horizAdvX: 582,
    d: "M478 692H558L377 0H205L24 692H104L263 68H319L478 692Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    glyphName: "W",
    horizAdvX: 886,
    d: "M30 692H110L228 68H257L398 686H488L629 68H658L776 692H855L715 0H574L443 591L312 0H171L30 692Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    glyphName: "X",
    horizAdvX: 558,
    d: "M106 692L281 396L457 692H540L327 341L540 0H453L279 287L102 0H19L233 339L19 692H106Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    glyphName: "Y",
    horizAdvX: 538,
    d: "M308 0H231V291L10 692H97L269 368L441 692H528L308 291V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    glyphName: "Z",
    horizAdvX: 536,
    d: "M43 624V692H493V602L131 88V68H493V-1H43V88L404 602V624H43Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    glyphName: "bracketleft",
    horizAdvX: 329,
    d: "M289 749V682H155V-56H289V-123H79V749H289Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    glyphName: "backslash",
    horizAdvX: 436,
    d: "M405 14L338 -14L30 678L97 707L405 14Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    glyphName: "bracketright",
    horizAdvX: 329,
    d: "M40 682V749H250V-123H40V-56H174V682H40Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    glyphName: "asciicircum",
    horizAdvX: 560,
    d: "M421 319L278 586L138 319H58L243 660H310L501 319H421Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    glyphName: "underscore",
    horizAdvX: 632,
    d: "M102 -92H530V-158H102V-92Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    glyphName: "grave",
    horizAdvX: 236,
    d: "M25 740L241 642L220 591L-1 676L25 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    glyphName: "a",
    horizAdvX: 501,
    d: "M425 349V93Q428 56 483 49L480 -10Q401 -10 361 30Q271 -10 181 -10Q112 -10 76 29T40 141T77 248T193 291L350 306V349Q350 400 328 422T268 444Q188 444 102 434L71 431L68 488Q178 510 263 510T386 471T425 349ZM117 145Q117 53 193 53Q261 53 327 76L350 84V249L202 235Q157 231 137 209T117 145Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    glyphName: "b",
    horizAdvX: 526,
    d: "M293 510Q394 510 434 453T475 251T425 49T239 -10Q197 -10 100 -2L72 1V718H146V475Q222 510 293 510ZM238 57Q336 57 367 101T399 252T374 400T285 443Q227 443 166 421L146 414V62Q211 57 238 57Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    glyphName: "c",
    horizAdvX: 436,
    d: "M259 510Q292 510 371 498L395 495L392 434Q312 443 274 443Q189 443 159 403T128 253T156 100T275 57L393 66L396 4Q303 -10 257 -10Q140 -10 96 50T51 252T99 452T259 510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    glyphName: "d",
    horizAdvX: 529,
    d: "M456 718V0H382V34Q305 -10 230 -10Q190 -10 160 0T104 36Q50 90 50 235T98 445T259 510Q317 510 382 497V718H456ZM178 71T196 64T242 57T306 66T362 85L382 94V433Q318 445 263 445Q187 445 157 397T127 246Q127 130 162 90Q178 71 196 64Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    glyphName: "e",
    horizAdvX: 505,
    d: "M412 62L441 65L443 6Q329 -10 248 -10Q140 -10 95 52T50 247Q50 510 259 510Q360 510 410 454T460 276L456 219H126Q126 136 156 96T260 56T412 62ZM385 279Q385 371 356 409T260 447T160 407T125 279H385Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    glyphName: "f",
    horizAdvX: 331,
    d: "M168 435V0H93V435H30V500H93V545Q93 651 123 689T228 728L329 721L328 659Q272 661 236 661T184 637T168 544V500H313V435H168Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    glyphName: "g",
    horizAdvX: 514,
    d: "M265 -235Q145 -235 98 -203T50 -84Q50 -43 68 -18T129 40Q101 59 101 109Q101 126 126 172L135 188Q56 224 56 339Q56 510 243 510Q291 510 332 500L347 497L495 501V437L400 439Q433 406 433 339Q433 245 387 208T240 170Q213 170 191 174Q173 130 173 117Q173 86 192 79T307 71T445 41T487 -76Q487 -235 265 -235ZM124 -78Q124 -131 153 -151T262 -172T376 -150T411 -77T386 -10T288 5L180 10Q147 -14 136 -32T124 -78ZM131 280T157 255T245 230T332 255T358 339T332 424T245 449T158 424T131 339Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    glyphName: "h",
    horizAdvX: 537,
    d: "M147 0H72V718H147V472Q227 510 301 510Q401 510 435 456T470 264V0H395V262Q395 366 375 404T288 443Q225 443 166 420L147 413V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    glyphName: "i",
    horizAdvX: 219,
    d: "M72 0V500H147V0H72ZM72 613V700H147V613H72Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    glyphName: "j",
    horizAdvX: 219,
    d: "M73 13V500H147V12Q147 -80 114 -126T-19 -223L-49 -165Q29 -120 51 -89T73 13ZM73 613V700H147V613H73Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    glyphName: "k",
    horizAdvX: 479,
    d: "M147 0H72V718H147V294L225 298L368 500H453L290 270L460 0H375L226 232L147 229V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    glyphName: "l",
    horizAdvX: 231,
    d: "M78 0V718H153V0H78Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    glyphName: "m",
    horizAdvX: 836,
    d: "M147 0H72V500H146V465Q221 510 292 510Q385 510 422 459Q455 479 507 494T600 510Q700 510 734 457T769 264V0H694V262Q694 366 674 404T589 443Q556 443 521 434T467 415L448 406Q461 373 461 260V0H386V258Q386 366 367 404T281 443Q249 443 216 434T164 415L147 406V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    glyphName: "n",
    horizAdvX: 537,
    d: "M147 0H72V500H146V465Q227 510 301 510Q401 510 435 456T470 264V0H396V262Q396 366 376 404T288 443Q256 443 221 434T166 415L147 406V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    glyphName: "o",
    horizAdvX: 528,
    d: "M50 388T99 449T264 510T429 449T478 251T432 52T264 -10T96 52T50 251ZM127 143T153 99T264 55T375 98T401 252T372 403T265 445T157 404T127 253Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    glyphName: "p",
    horizAdvX: 527,
    d: "M72 -222V500H146V464Q222 510 296 510Q391 510 434 450T477 250T427 51T259 -10Q198 -10 147 1V-222H72ZM285 443Q255 443 221 433T166 413L147 403V66Q218 55 255 55Q336 55 368 101T401 251T372 399T285 443Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    glyphName: "q",
    horizAdvX: 526,
    d: "M238 -10Q137 -10 94 49T50 249T102 450T286 510L453 500V-222H379V23Q309 -10 238 -10ZM287 445Q193 445 160 398T126 249T153 102T246 57Q304 57 361 79L379 86V439Q317 445 287 445Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    glyphName: "r",
    horizAdvX: 346,
    d: "M72 0V500H146V432Q233 492 329 511V435Q287 427 242 410T172 380L147 367V0H72Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    glyphName: "s",
    horizAdvX: 465,
    d: "M229 443Q120 443 120 367Q120 332 145 318T259 288T385 244T422 139T373 26T228 -10Q166 -10 82 4L52 9L56 74Q170 57 228 57T316 75T347 137T321 196T207 226T82 267T45 367T96 475T225 510Q286 510 378 496L406 491L404 427Q293 443 229 443Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    glyphName: "t",
    horizAdvX: 351,
    d: "M331 435H172V196Q172 110 184 83T244 56L333 62L338 0Q271 -11 236 -11Q158 -11 128 27T98 172V435H27V500H98V653H172V500H331V435Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    glyphName: "u",
    horizAdvX: 531,
    d: "M384 500H459V0H384V35Q309 -10 236 -10Q134 -10 101 43T67 239V500H142V240Q142 131 161 94T247 57Q280 57 314 66T366 85L384 94V500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    glyphName: "v",
    horizAdvX: 481,
    d: "M25 500H105L222 65H259L380 500H457L316 0H166L25 500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    glyphName: "w",
    horizAdvX: 762,
    d: "M31 500H106L207 65H223L342 490H420L539 65H556L656 500H731L612 0H487L381 391L275 0H150L31 500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    glyphName: "x",
    horizAdvX: 452,
    d: "M22 500H104L226 304L348 500H430L271 252L429 0H347L226 195L104 0H22L179 250L22 500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    glyphName: "y",
    horizAdvX: 483,
    d: "M25 500H100L225 65H258L384 500H459L251 -222H176L241 0H167L25 500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    glyphName: "z",
    horizAdvX: 455,
    d: "M42 433V500H413V433L133 67H413V0H42V67L322 433H42Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    glyphName: "braceleft",
    horizAdvX: 352,
    d: "M197 575L204 452Q204 388 183 359T99 312Q160 294 182 264T204 170L197 54Q197 -2 221 -30T312 -63L310 -128Q209 -124 167 -84T124 47L131 169Q131 212 106 238T24 281V342Q81 355 106 381T131 451L124 579Q124 671 166 711T311 755L312 690Q246 686 222 659T197 575Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    glyphName: "bar",
    horizAdvX: 230,
    d: "M78 -222V718H152V-222H78Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    glyphName: "braceright",
    horizAdvX: 352,
    d: "M155 54L148 170Q148 233 170 263T253 312Q191 330 170 359T148 452L155 575Q155 631 131 658T40 690L41 755Q143 751 185 711T228 579L221 451Q221 408 246 382T328 342V281Q271 265 246 239T221 169L228 47Q228 -43 186 -83T42 -128L40 -63Q106 -59 130 -31T155 54Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    glyphName: "asciitilde",
    horizAdvX: 560,
    d: "M379 195Q352 195 277 226T183 257T138 246T95 222L78 210L67 272Q129 325 183 325Q212 325 286 295T380 264Q415 264 468 298L485 310L495 249Q432 195 379 195Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    glyphName: "uni00A0",
    horizAdvX: 220
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    glyphName: "exclamdown",
    horizAdvX: 228,
    d: "M154 500V388H72V500H154ZM148 272L153 -192H74L79 272H148Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    glyphName: "cent",
    horizAdvX: 560,
    d: "M278 -81V36Q185 41 143 88T101 246T144 408T278 465V583H343V462Q382 462 428 453L444 450L441 390Q362 397 312 397Q238 397 209 364T179 248T208 135T318 103L442 110L445 49Q385 40 343 38V-81H278Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    glyphName: "sterling",
    horizAdvX: 560,
    d: "M445 592Q365 603 319 603T255 575T238 467V417H409V352H238V66H392L469 82L482 18L400 0H80V66H165V352H98V417H165V472Q165 589 198 629T313 670Q365 670 424 658L446 653L445 592Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    glyphName: "currency",
    horizAdvX: 560,
    d: "M379 101Q333 71 279 71T181 101L111 30L58 83L128 153Q99 198 99 251T128 351L58 421L111 474L181 403Q225 433 279 433T379 403L449 474L502 421L431 351Q461 305 461 251T431 153L502 83L449 30L379 101ZM233 137T280 137T361 171T395 252T361 333T280 367T199 333T165 252T199 171Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    glyphName: "yen",
    horizAdvX: 560,
    d: "M57 315V380H197L23 660H109L281 390L451 660H537L366 380H502V315H328L320 296V228H503V163H320V0H243V163H58V228H243V296L235 315H57Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    glyphName: "brokenbar",
    horizAdvX: 234,
    d: "M80 718H154V344H80V718ZM80 156H154V-222H80V156Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    glyphName: "section",
    horizAdvX: 499,
    d: "M418 571Q309 586 253 586T168 564T139 494T169 428T285 393T406 348T443 251T399 118Q436 86 436 18Q436 -150 245 -150Q181 -150 100 -138L70 -133L77 -70Q186 -85 241 -85Q364 -85 364 14Q364 59 335 74T218 106T91 154T52 255Q52 294 73 331T110 381Q66 413 66 492Q66 651 258 651Q309 651 396 638L422 634L418 571ZM160 354Q127 299 127 261T152 203T244 172T342 146Q347 153 357 182T367 248T342 302T252 331T160 354Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    glyphName: "dieresis",
    horizAdvX: 236,
    d: "M-12 621V711H60V621H-12ZM188 621V711H261V621H188Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    glyphName: "copyright",
    horizAdvX: 645,
    d: "M210 161T135 240T59 434T134 628T323 707T511 628T586 433T512 240T324 161ZM103 530T103 434T165 272T322 205T479 271T542 434T479 597T323 664T166 597ZM326 276Q261 276 235 313T209 433T235 553T327 591Q364 591 394 584L404 581L400 528Q362 534 328 534T282 512T270 436T282 358T330 333L400 340L404 288Q367 276 326 276Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    glyphName: "ordfeminine",
    horizAdvX: 386,
    d: "M302 560V423Q311 412 332 406L330 357Q292 357 276 363T247 383Q192 357 146 357T77 382T54 449Q54 529 150 535L238 541V563Q238 585 226 594T189 603L74 596L72 644Q141 659 195 659T275 637T302 560ZM120 450Q120 411 156 411Q185 411 226 424L238 428V495L161 490Q139 488 130 479T120 450Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    glyphName: "guillemotleft",
    horizAdvX: 539,
    d: "M234 344L110 250L234 145V67L45 218V278L234 421V344ZM472 344L347 250L472 145V67L282 218V278L472 421V344Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    glyphName: "logicalnot",
    horizAdvX: 560,
    d: "M65 342H493V117H423V274H65V342Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    glyphName: "registered",
    horizAdvX: 645,
    d: "M210 161T135 240T59 434T134 628T323 707T511 628T586 434T512 240T324 161ZM229 664T166 597T103 435T166 272T322 205T479 271T542 434T479 597T323 664ZM271 389V282H213V585H323Q380 585 408 563T437 497T426 432T386 397L441 282H380L330 389H271ZM270 538V436H329Q356 436 368 448T380 487Q380 538 318 538H270Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    glyphName: "overscore",
    horizAdvX: 236,
    d: "M-14 624V683H261V624H-14Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    glyphName: "degree",
    horizAdvX: 560,
    d: "M138 498T138 561T177 663T280 702T382 663T422 561T383 459T280 420T178 459ZM239 654T214 628T189 561T214 494T280 468T347 493T373 560T347 628T280 654Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    glyphName: "plusminus",
    horizAdvX: 560,
    d: "M55 293V361H244V487H314V361H505V293H314V166H244V293H55ZM55 106H505V38H55V106Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    glyphName: "twosuperior",
    horizAdvX: 280,
    d: "M239 478H30V533L118 620Q169 669 169 703Q169 740 120 740L35 731L33 788Q92 800 140 800Q235 800 235 709Q235 676 221 652T174 597L111 536H239V478Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    glyphName: "threesuperior",
    horizAdvX: 280,
    d: "M136 800Q241 800 241 716Q241 665 202 643Q226 635 237 619T249 565Q249 468 143 468Q100 468 48 476L30 478L34 534Q91 526 137 526T184 568T137 611H72V664H137Q151 664 163 677T175 708Q175 742 130 742L38 735L34 790Q93 800 136 800Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    glyphName: "acute",
    horizAdvX: 268,
    d: "M26 642L242 740L268 676L47 591L26 642Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    glyphName: "mu",
    horizAdvX: 560,
    d: "M401 500H476V0H401V35Q326 -10 261 -10T159 7V-222H84V500H159V240Q159 131 178 94T264 57Q297 57 331 66T383 85L401 94V500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    glyphName: "paragraph",
    horizAdvX: 593,
    d: "M411 0V627H295V0H228V324H221Q140 324 88 375T35 507T88 640T222 692H551V627H479V0H411Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    glyphName: "middot",
    horizAdvX: 217,
    d: "M68 229V343H150V229H68Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    glyphName: "cedilla",
    horizAdvX: 263,
    d: "M221 -127Q221 -217 128 -217Q82 -217 54 -212L42 -210L45 -162Q84 -165 111 -165Q155 -165 155 -127Q155 -93 111 -93H69V1H110V-49Q169 -49 195 -65T221 -127Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    glyphName: "onesuperior",
    horizAdvX: 280,
    d: "M193 790V478H129V720L61 673L32 720L133 790H193Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    glyphName: "ordmasculine",
    horizAdvX: 380,
    d: "M53 587T87 623T190 659T292 623T326 510Q326 357 191 357Q53 357 53 510Q53 587 87 623ZM122 461T137 440T190 418T242 439T257 510T243 578T191 598T138 578T122 510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    glyphName: "guillemotright",
    horizAdvX: 539,
    d: "M429 250L304 344V421L494 278V218L304 67V145L429 250ZM192 250L67 344V421L256 278V218L67 67V145L192 250Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    glyphName: "onequarter",
    horizAdvX: 534,
    d: "M198 790V478H134V720L66 673L37 720L138 790H198ZM35 28L427 660L467 634L74 3L35 28ZM412 -100V-52H271V2L340 212H410L337 6H412L417 95H475V6H502V-52H475V-100H412Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    glyphName: "onehalf",
    horizAdvX: 529,
    d: "M202 790V478H138V720L70 673L41 720L142 790H202ZM33 28L425 660L465 634L72 3L33 28ZM486 -100H277V-45L365 42Q416 91 416 125Q416 162 367 162L282 153L280 210Q339 222 386 222Q482 222 482 131Q482 98 468 74T421 19L358 -42H486V-100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    glyphName: "threequarters",
    horizAdvX: 550,
    d: "M155 800Q260 800 260 716Q260 665 221 643Q245 635 256 619T268 565Q268 468 162 468Q119 468 66 476L49 478L53 534Q110 526 156 526T203 568T156 611H91V664H156Q170 664 182 677T194 708Q194 742 149 742L57 735L53 790Q112 800 155 800ZM52 28L444 660L484 634L91 3L52 28ZM429 -100V-52H288V2L357 212H427L354 6H429L434 95H492V6H519V-52H492V-100H429Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    glyphName: "questiondown",
    horizAdvX: 441,
    d: "M38 -41Q38 24 55 57T126 135T200 206T220 265V300H283Q296 273 296 239T273 176T199 102T131 32T114 -40T146 -110T247 -133Q300 -133 376 -116L402 -110L407 -171Q306 -201 240 -201Q137 -201 88 -164T38 -41ZM294 500V388H212V500H294Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    glyphName: "Agrave",
    horizAdvX: 596,
    d: "M24 0L214 692H382L572 0H496L446 178H150L100 0H24ZM272 626L167 247H429L324 626H272ZM189 931L405 831L382 778L163 865L189 931Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    glyphName: "Aacute",
    horizAdvX: 596,
    d: "M24 0L214 692H382L572 0H496L446 178H150L100 0H24ZM272 626L167 247H429L324 626H272ZM186 831L402 931L428 865L209 778L186 831Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    glyphName: "Acircumflex",
    horizAdvX: 596,
    d: "M24 0L214 692H382L572 0H496L446 178H150L100 0H24ZM272 626L167 247H429L324 626H272ZM130 791L264 926H329L463 791H379L297 871L214 791H130Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    glyphName: "Atilde",
    horizAdvX: 596,
    d: "M24 0L214 692H382L572 0H496L446 178H150L100 0H24ZM272 626L167 247H429L324 626H272ZM374 803Q353 803 291 830T216 857Q194 857 155 821L142 809L125 865Q144 887 170 905T219 923T303 896T374 869Q394 869 432 904L444 915L462 859Q415 803 374 803Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    glyphName: "Adieresis",
    horizAdvX: 596,
    d: "M24 0L214 692H382L572 0H496L446 178H150L100 0H24ZM272 626L167 247H429L324 626H272ZM159 808V898H232V808H159ZM363 808V898H435V808H363Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    glyphName: "Aring",
    horizAdvX: 596,
    d: "M349 849T382 821T415 747T387 671L572 0H496L446 178H150L100 0H24L208 669Q178 697 178 745T211 821T297 849ZM272 626L167 247H429L324 626H272ZM235 744Q235 700 278 692H315Q359 700 359 744Q359 769 343 783T297 797Q235 797 235 744Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    glyphName: "AE",
    horizAdvX: 876,
    d: "M408 0V175H157L99 0H20L244 696H829V623H484V393H769V320H484V73H829V0H408ZM300 623L178 249H408L409 623H300Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    glyphName: "Ccedilla",
    horizAdvX: 544,
    d: "M433 -127Q433 -217 340 -217Q294 -217 266 -212L254 -210L257 -162Q296 -165 323 -165Q367 -165 367 -127Q367 -93 323 -93H281V-9Q152 0 106 84T59 344Q59 437 69 499T107 610T185 680T315 702T503 680L500 615Q399 633 320 633Q210 633 175 568T139 344Q139 265 145 217T171 131T226 76T333 59T500 77L503 11Q411 -9 322 -10V-49Q381 -49 407 -65T433 -127Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    glyphName: "Egrave",
    horizAdvX: 553,
    d: "M85 0V692H506V624H162V385H446V318H162V68H506V0H85ZM195 931L411 831L388 778L169 865L195 931Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    glyphName: "Eacute",
    horizAdvX: 553,
    d: "M85 0V692H506V624H162V385H446V318H162V68H506V0H85ZM176 831L392 931L418 865L199 778L176 831Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    glyphName: "Ecircumflex",
    horizAdvX: 553,
    d: "M85 0V692H506V624H162V385H446V318H162V68H506V0H85ZM127 791L261 926H326L460 791H376L294 871L211 791H127Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    glyphName: "Edieresis",
    horizAdvX: 553,
    d: "M85 0V692H506V624H162V385H446V318H162V68H506V0H85ZM157 808V898H230V808H157ZM361 808V898H433V808H361Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    glyphName: "Igrave",
    horizAdvX: 246,
    d: "M85 0V692H162V0H85ZM6 931L222 831L199 778L-20 865L6 931Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    glyphName: "Iacute",
    horizAdvX: 246,
    d: "M85 0V692H162V0H85ZM13 831L229 931L255 865L36 778L13 831Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    glyphName: "Icircumflex",
    horizAdvX: 246,
    d: "M85 0V692H162V0H85ZM-47 791L87 926H152L286 791H202L120 871L37 791H-47Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    glyphName: "Idieresis",
    horizAdvX: 246,
    d: "M85 0V692H162V0H85ZM-15 808V898H58V808H-15ZM189 808V898H261V808H189Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    glyphName: "Eth",
    horizAdvX: 647,
    d: "M20 311V384H88V696H335Q476 696 533 608T591 359Q591 97 460 28Q409 0 335 0H88V311H20ZM511 359Q511 553 422 603Q387 623 335 623H164V384H322V311H164V73H335Q511 73 511 359Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    glyphName: "Ntilde",
    horizAdvX: 676,
    d: "M85 0V692H229L494 68H515V692H591V0H450L181 624H162V0H85ZM416 803Q395 803 333 830T258 857Q236 857 197 821L184 809L167 865Q186 887 212 905T261 923T345 896T416 869Q436 869 474 904L486 915L504 859Q457 803 416 803Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    glyphName: "Ograve",
    horizAdvX: 660,
    d: "M136 191T176 125T330 58T484 123T524 341T483 564T330 634T177 565T136 343ZM604 156T545 73T331 -10T116 75T57 342T117 613T330 702T543 614T604 341ZM227 931L443 831L420 778L201 865L227 931Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    glyphName: "Oacute",
    horizAdvX: 660,
    d: "M136 191T176 125T330 58T484 123T524 341T483 564T330 634T177 565T136 343ZM604 156T545 73T331 -10T116 75T57 342T117 613T330 702T543 614T604 341ZM198 831L414 931L440 865L221 778L198 831Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    glyphName: "Ocircumflex",
    horizAdvX: 660,
    d: "M136 191T176 125T330 58T484 123T524 341T483 564T330 634T177 565T136 343ZM604 156T545 73T331 -10T116 75T57 342T117 613T330 702T543 614T604 341ZM164 791L298 926H363L497 791H413L331 871L248 791H164Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    glyphName: "Otilde",
    horizAdvX: 660,
    d: "M136 191T176 125T330 58T484 123T524 341T483 564T330 634T177 565T136 343ZM604 156T545 73T331 -10T116 75T57 342T117 613T330 702T543 614T604 341ZM408 803Q387 803 325 830T250 857Q228 857 189 821L176 809L159 865Q178 887 204 905T253 923T337 896T408 869Q428 869 466 904L478 915L496 859Q449 803 408 803Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    glyphName: "Odieresis",
    horizAdvX: 660,
    d: "M136 191T176 125T330 58T484 123T524 341T483 564T330 634T177 565T136 343ZM604 156T545 73T331 -10T116 75T57 342T117 613T330 702T543 614T604 341ZM192 808V898H265V808H192ZM396 808V898H468V808H396Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    glyphName: "multiply",
    horizAdvX: 560,
    d: "M120 459L280 297L441 460L489 412L326 251L489 90L441 42L280 204L119 42L71 90L233 251L71 411L120 459Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    glyphName: "Oslash",
    horizAdvX: 660,
    d: "M330 -10Q261 -10 210 7L153 -116L96 -90L155 36Q102 76 80 151T57 343Q57 525 117 613T330 702Q405 702 456 681L512 799L570 775L511 648Q604 570 604 343Q604 156 545 73T330 -10ZM217 634T177 565T136 331T188 108L426 615Q388 634 330 634Q217 634 177 565ZM330 58Q445 58 484 123T524 349T476 574L241 72Q275 58 330 58Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    glyphName: "Ugrave",
    horizAdvX: 644,
    d: "M157 208Q157 58 319 58Q403 58 445 93T488 208V692H564V210Q564 94 503 42T321 -10T141 42T80 210V692H157V208ZM222 931L438 831L415 778L196 865L222 931Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    glyphName: "Uacute",
    horizAdvX: 644,
    d: "M157 208Q157 58 319 58Q403 58 445 93T488 208V692H564V210Q564 94 503 42T321 -10T141 42T80 210V692H157V208ZM199 831L415 931L441 865L222 778L199 831Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    glyphName: "Ucircumflex",
    horizAdvX: 644,
    d: "M157 208Q157 58 319 58Q403 58 445 93T488 208V692H564V210Q564 94 503 42T321 -10T141 42T80 210V692H157V208ZM155 791L289 926H354L488 791H404L322 871L239 791H155Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    glyphName: "Udieresis",
    horizAdvX: 644,
    d: "M157 208Q157 58 319 58Q403 58 445 93T488 208V692H564V210Q564 94 503 42T321 -10T141 42T80 210V692H157V208ZM184 808V898H257V808H184ZM388 808V898H460V808H388Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    glyphName: "Yacute",
    horizAdvX: 538,
    d: "M308 0H231V291L10 692H97L269 368L441 692H528L308 291V0ZM167 831L383 931L409 865L190 778L167 831Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    glyphName: "Thorn",
    horizAdvX: 599,
    d: "M337 195Q481 195 481 361Q481 439 447 474T337 510H162V195H337ZM338 121H162V0H85V696H162V584H338Q451 584 505 529T560 360T505 183T338 121Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    glyphName: "germandbls",
    horizAdvX: 574,
    d: "M147 0H72V545Q72 646 117 687T267 728T416 694T462 584Q462 531 443 503T384 457T333 430T321 406T337 377T419 332T511 268T539 177Q539 75 494 33T338 -10Q288 -10 228 1L207 5L210 68Q295 57 332 57Q404 57 432 83T461 158T440 229T354 282T266 337T243 398T261 456T319 494T371 529T384 586T359 643T267 661T174 635T147 536V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    glyphName: "agrave",
    horizAdvX: 501,
    d: "M425 349V93Q428 56 483 49L480 -10Q401 -10 361 30Q271 -10 181 -10Q112 -10 76 29T40 141T77 248T193 291L350 306V349Q350 400 328 422T268 444Q188 444 102 434L71 431L68 488Q178 510 263 510T386 471T425 349ZM117 145Q117 53 193 53Q261 53 327 76L350 84V249L202 235Q157 231 137 209T117 145ZM147 740L363 642L342 591L121 676L147 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    glyphName: "aacute",
    horizAdvX: 501,
    d: "M425 349V93Q428 56 483 49L480 -10Q401 -10 361 30Q271 -10 181 -10Q112 -10 76 29T40 141T77 248T193 291L350 306V349Q350 400 328 422T268 444Q188 444 102 434L71 431L68 488Q178 510 263 510T386 471T425 349ZM117 145Q117 53 193 53Q261 53 327 76L350 84V249L202 235Q157 231 137 209T117 145ZM118 642L334 740L360 676L139 591L118 642Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    glyphName: "acircumflex",
    horizAdvX: 501,
    d: "M425 349V93Q428 56 483 49L480 -10Q401 -10 361 30Q271 -10 181 -10Q112 -10 76 29T40 141T77 248T193 291L350 306V349Q350 400 328 422T268 444Q188 444 102 434L71 431L68 488Q178 510 263 510T386 471T425 349ZM117 145Q117 53 193 53Q261 53 327 76L350 84V249L202 235Q157 231 137 209T117 145ZM95 592L218 732H269L393 592H318L245 679L170 592H95Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    glyphName: "atilde",
    horizAdvX: 501,
    d: "M425 349V93Q428 56 483 49L480 -10Q401 -10 361 30Q271 -10 181 -10Q112 -10 76 29T40 141T77 248T193 291L350 306V349Q350 400 328 422T268 444Q188 444 102 434L71 431L68 488Q178 510 263 510T386 471T425 349ZM117 145Q117 53 193 53Q261 53 327 76L350 84V249L202 235Q157 231 137 209T117 145ZM307 612Q286 612 235 635T170 659Q147 659 108 629L95 619L77 667Q127 719 168 719Q189 719 241 696T304 673Q326 673 364 702L376 711L393 663Q347 612 307 612Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    glyphName: "adieresis",
    horizAdvX: 501,
    d: "M425 349V93Q428 56 483 49L480 -10Q401 -10 361 30Q271 -10 181 -10Q112 -10 76 29T40 141T77 248T193 291L350 306V349Q350 400 328 422T268 444Q188 444 102 434L71 431L68 488Q178 510 263 510T386 471T425 349ZM117 145Q117 53 193 53Q261 53 327 76L350 84V249L202 235Q157 231 137 209T117 145ZM105 621V711H177V621H105ZM305 621V711H378V621H305Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    glyphName: "aring",
    horizAdvX: 501,
    d: "M425 349V93Q428 56 483 49L480 -10Q401 -10 361 30Q271 -10 181 -10Q112 -10 76 29T40 141T77 248T193 291L350 306V349Q350 400 328 422T268 444Q188 444 102 434L71 431L68 488Q178 510 263 510T386 471T425 349ZM117 145Q117 53 193 53Q261 53 327 76L350 84V249L202 235Q157 231 137 209T117 145ZM151 601T151 645T181 719T254 749T328 719T358 645T329 571T255 541T181 571ZM232 701T216 685T200 645T216 605T255 588T294 604T310 644T294 684T255 701Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    glyphName: "ae",
    horizAdvX: 804,
    d: "M710 65L739 67L741 6Q628 -10 538 -10T400 44L368 30Q281 -10 176 -10Q109 -10 75 29T40 146T81 253T221 294L350 306V347Q350 438 263 438Q197 438 104 430L73 428L70 495Q189 510 267 510Q369 510 402 437Q450 510 554 510T709 454T759 276L755 218H425Q425 136 455 97T546 58T710 65ZM188 55Q234 55 293 69T367 92Q348 143 348 245L202 233Q158 229 138 208T117 145Q117 55 188 55ZM425 279H684Q684 368 655 405T559 443T459 404T425 279Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    glyphName: "ccedilla",
    horizAdvX: 436,
    d: "M360 -127Q360 -217 267 -217Q221 -217 192 -212L181 -210L184 -162Q223 -165 250 -165Q294 -165 294 -127Q294 -93 250 -93H208V-7Q120 3 86 64T51 260T99 452T259 510Q292 510 371 498L395 495L392 434Q312 443 274 443Q189 443 159 403T128 253T156 100T275 57L393 66L396 4Q303 -10 257 -10H249V-49Q308 -49 334 -65T360 -127Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    glyphName: "egrave",
    horizAdvX: 505,
    d: "M412 62L441 65L443 6Q329 -10 248 -10Q140 -10 95 52T50 247Q50 510 259 510Q360 510 410 454T460 276L456 219H126Q126 136 156 96T260 56T412 62ZM385 279Q385 371 356 409T260 447T160 407T125 279H385ZM147 741L363 643L342 592L121 677L147 741Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    glyphName: "eacute",
    horizAdvX: 505,
    d: "M412 62L441 65L443 6Q329 -10 248 -10Q140 -10 95 52T50 247Q50 510 259 510Q360 510 410 454T460 276L456 219H126Q126 136 156 96T260 56T412 62ZM385 279Q385 371 356 409T260 447T160 407T125 279H385ZM145 642L361 740L387 676L166 591L145 642Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    glyphName: "ecircumflex",
    horizAdvX: 505,
    d: "M412 62L441 65L443 6Q329 -10 248 -10Q140 -10 95 52T50 247Q50 510 259 510Q360 510 410 454T460 276L456 219H126Q126 136 156 96T260 56T412 62ZM385 279Q385 371 356 409T260 447T160 407T125 279H385ZM112 592L235 732H286L410 592H335L262 679L187 592H112Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    glyphName: "edieresis",
    horizAdvX: 505,
    d: "M412 62L441 65L443 6Q329 -10 248 -10Q140 -10 95 52T50 247Q50 510 259 510Q360 510 410 454T460 276L456 219H126Q126 136 156 96T260 56T412 62ZM385 279Q385 371 356 409T260 447T160 407T125 279H385ZM120 621V711H192V621H120ZM320 621V711H393V621H320Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    glyphName: "igrave",
    horizAdvX: 219,
    d: "M72 0V500H147V0H72ZM-34 740L182 642L161 591L-60 676L-34 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    glyphName: "iacute",
    horizAdvX: 219,
    d: "M38 642L254 740L280 676L59 591L38 642ZM72 500H147V0H72V500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    glyphName: "icircumflex",
    horizAdvX: 219,
    d: "M72 500H147V0H72V500ZM-42 592L81 732H132L256 592H181L108 679L33 592H-42Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    glyphName: "idieresis",
    horizAdvX: 219,
    d: "M72 500H147V0H72V500ZM-31 621V711H41V621H-31ZM169 621V711H242V621H169Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    glyphName: "eth",
    horizAdvX: 548,
    d: "M342 643Q496 545 496 352T442 75T265 -9Q158 -9 100 48T42 209T97 371T252 430Q317 430 392 403L417 394Q410 524 280 601L158 520L125 567L220 631Q166 654 96 672L111 728Q211 708 284 674L385 742L419 695L342 643ZM418 327Q328 363 260 363T157 322T121 210T157 100T270 59T382 118T418 327Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    glyphName: "ntilde",
    horizAdvX: 537,
    d: "M72 0V500H146V465L168 476Q191 488 229 499T301 510Q401 510 435 456T470 264Q470 264 470 0H396V262Q396 366 376 404T286 443T147 406V0H72ZM349 612Q328 612 277 635T212 659Q189 659 150 629L137 619L119 667Q169 719 210 719Q231 719 283 696T346 673Q368 673 406 702L418 711L435 663Q389 612 349 612Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    glyphName: "ograve",
    horizAdvX: 528,
    d: "M50 388T99 449T264 510T429 449T478 251T432 52T264 -10T96 52T50 251ZM127 143T153 99T264 55T375 98T401 252T372 403T265 445T157 404T127 253ZM167 740L383 642L362 591L141 676L167 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    glyphName: "oacute",
    horizAdvX: 528,
    d: "M381 510T429 449T478 251T432 52T264 -10T96 52T50 251T99 449T264 510ZM349 55T375 98T401 252T372 403T265 445T157 404T127 253T153 99T264 55ZM154 642L370 740L396 676L175 591L154 642Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    glyphName: "ocircumflex",
    horizAdvX: 528,
    d: "M381 510T429 449T478 251T432 52T264 -10T96 52T50 251T99 449T264 510ZM349 55T375 98T401 252T372 403T265 445T157 404T127 253T153 99T264 55ZM113 592L236 732H287L411 592H336L263 679L188 592H113Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    glyphName: "otilde",
    horizAdvX: 528,
    d: "M381 510T429 449T478 251T432 52T264 -10T96 52T50 251T99 449T264 510ZM349 55T375 98T401 252T372 403T265 445T157 404T127 253T153 99T264 55ZM335 612Q314 612 263 635T198 659Q175 659 136 629L123 619L105 667Q155 719 196 719Q217 719 269 696T332 673Q354 673 392 702L404 711L421 663Q375 612 335 612Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    glyphName: "odieresis",
    horizAdvX: 528,
    d: "M381 510T429 449T478 251T432 52T264 -10T96 52T50 251T99 449T264 510ZM349 55T375 98T401 252T372 403T265 445T157 404T127 253T153 99T264 55ZM125 621V711H197V621H125ZM325 621V711H398V621H325Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    glyphName: "divide",
    horizAdvX: 560,
    d: "M120 281V354H177V402H383V354H439V281H120ZM242 30V131H317V30H242Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    glyphName: "oslash",
    horizAdvX: 528,
    d: "M264 510Q303 510 338 502L381 606L431 587L388 483Q478 433 478 256Q478 114 432 52T264 -10Q223 -10 188 -2L145 -112L95 -94L139 15Q90 42 70 100T50 256Q50 388 99 449T264 510ZM264 445Q186 445 157 404T127 273T135 142T169 80L314 439Q293 445 264 445ZM264 55Q349 55 375 98T401 260T359 417L213 60Q231 55 264 55Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    glyphName: "ugrave",
    horizAdvX: 531,
    d: "M384 500H459V0H384V35Q309 -10 236 -10Q134 -10 101 43T67 239V500H142V240Q142 131 161 94T247 57Q280 57 314 66T366 85L384 94V500ZM140 740L356 642L335 591L114 676L140 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    glyphName: "uacute",
    horizAdvX: 531,
    d: "M459 500V0H384V35L363 24Q342 12 305 1T236 -10Q134 -10 101 43T67 239Q67 239 67 500H142V240Q142 131 161 94T250 57T384 94V500H459ZM155 642L371 740L397 676L176 591L155 642Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    glyphName: "ucircumflex",
    horizAdvX: 531,
    d: "M459 500V0H384V35L363 24Q342 12 305 1T236 -10Q134 -10 101 43T67 239Q67 239 67 500H142V240Q142 131 161 94T250 57T384 94V500H459ZM105 592L228 732H279L403 592H328L255 679L180 592H105Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    glyphName: "udieresis",
    horizAdvX: 531,
    d: "M459 500V0H384V35L363 24Q342 12 305 1T236 -10Q134 -10 101 43T67 239Q67 239 67 500H142V240Q142 131 161 94T250 57T384 94V500H459ZM132 621V711H204V621H132ZM332 621V711H405V621H332Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    glyphName: "yacute",
    horizAdvX: 483,
    d: "M25 500H100L225 65H258L384 500H459L251 -222H176L241 0H167L25 500ZM154 642L370 740L396 676L175 591L154 642Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    glyphName: "thorn",
    horizAdvX: 527,
    d: "M244 55Q338 55 368 100T399 251T375 400T286 443Q228 443 166 421L147 414V61Q212 55 244 55ZM293 510Q394 510 435 453T476 252T427 50T248 -10L147 -3V-222H72V718H147V475Q222 510 293 510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    glyphName: "ydieresis",
    horizAdvX: 483,
    d: "M25 500H100L225 65H258L384 500H459L251 -222H176L241 0H167L25 500ZM104 621V711H176V621H104ZM304 621V711H377V621H304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    glyphName: "endash",
    horizAdvX: 631,
    d: "M66 301H566V235H66V301Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    glyphName: "emdash",
    horizAdvX: 1131,
    d: "M66 301H1066V235H66V301Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    glyphName: "quoteleft",
    horizAdvX: 219,
    d: "M174 708L130 489H51L115 708H174Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    glyphName: "quoteright",
    horizAdvX: 216,
    d: "M53 489L97 708H176L112 489H53Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    glyphName: "quotesinglbase",
    horizAdvX: 218,
    d: "M93 22L84 -21H68L81 22H93Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    glyphName: "quotedblleft",
    horizAdvX: 373,
    d: "M327 708L283 489H204L268 708H327ZM174 708L130 489H51L115 708H174Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    glyphName: "quotedblright",
    horizAdvX: 377,
    d: "M53 490L97 709H176L112 490H53ZM213 490L257 709H336L272 490H213Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    glyphName: "quotedblbase",
    horizAdvX: 359,
    d: "M145 112L101 -107H22L86 112H145ZM297 112L253 -107H174L238 112H297Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    glyphName: "bullet",
    horizAdvX: 473,
    d: "M111 106V392H361V106H111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    glyphName: "guilsinglleft",
    horizAdvX: 301,
    d: "M234 344L110 250L234 145V67L45 218V278L234 421V344Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    glyphName: "guilsinglright",
    horizAdvX: 301,
    d: "M191 254L67 348V425L256 282V222L67 71V149L191 254Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitilliumWebV8LatinRegular);
export default __webpack_public_path__ + "static/media/titillium-web-v8-latin-regular.492c4431d0d8ce8518ca399bbd39ede6.svg";
export { ForwardRef as ReactComponent };